import {AccountState, RECONNECT_REQUIRED_ACCOUNT_STATES} from '@Components/social-media/account.vo';

/**
 * User-facing checkbox options for the account status filter. Each maps to a GROUP of
 * AccountState keys in accountStateFilter — NEEDS_VALIDATION/REFRESHING are transient,
 * internal health states getEffectiveAccountState never surfaces, so they have no checkbox.
 */
export enum AccountStatusCheckboxGroup {
  CONNECTED = 'CONNECTED',
  NEEDS_RECONNECTION = 'NEEDS_RECONNECTION',
}

export const ACCOUNT_STATUS_CHECKBOX_GROUP_STATES: Record<AccountStatusCheckboxGroup, AccountState[]> = {
  [AccountStatusCheckboxGroup.CONNECTED]: [AccountState.CONNECTED, AccountState.HEALTHY],
  [AccountStatusCheckboxGroup.NEEDS_RECONNECTION]: RECONNECT_REQUIRED_ACCOUNT_STATES,
};
